import AuthenticationInterface from 'authentication-interface';

import StartupInterface from './startup';

import SystemInterface from './public/system';

import HelptapUserInterface from './user/helptap';
import StartupUserInterface from './user/startup';

import { mergeInstancesInToInterface } from 'utilities';

import userAccessScopes from 'constants/user-access-scopes';

class ServerInterface {

  initialize(apiClient) {

    this.apiClient = apiClient;
    this.system = new SystemInterface(this.apiClient);
    this.authentication = new AuthenticationInterface(this.apiClient);
    this.startup = new StartupInterface(this.apiClient);

  }

  configureStartupAndCurrentUserServerInterfaces(startup, userId, accessScope) {

    this.startup.setBaseParameters(userId, startup._id, startup.communities[0]._id);

    if (accessScope === userAccessScopes.HELPTAP) {
      const helptapUserInterface = new HelptapUserInterface(this.apiClient, userId);
      const startupUserInterface = new StartupUserInterface(this.apiClient, startup._id, userId);
      this.currentUser = mergeInstancesInToInterface([helptapUserInterface, startupUserInterface], []);
    } else {
      this.currentUser = new StartupUserInterface(this.apiClient, startup._id, userId);
    }

  }

  configureStartupInterface(startupId, communityId) {

    this.startup.setBaseParameters('', startupId, communityId);

  }

}

const serverInterface = new ServerInterface();

export default serverInterface;